import React from 'react';
interface ButtonProps {
  variant: 'primary' | 'secondary';
  onClick?: () => void;
  children: React.ReactNode;
  className?: string;
}
export function Button({
  variant,
  onClick,
  children,
  className = ''
}: ButtonProps) {
  const baseStyles = 'px-6 py-3 rounded-lg font-semibold transition-all duration-200 flex items-center gap-2';
  const variantStyles = {
    primary: 'bg-gradient-to-r from-[#C8B84D] to-[#D4C94A] text-[#1B3A5C] hover:shadow-lg hover:brightness-105',
    secondary: 'border-2 border-primary text-primary bg-transparent hover:bg-primary hover:text-white'
  };
  return <button onClick={onClick} className={`${baseStyles} ${variantStyles[variant]} ${className}`} type="button" data-id="element-14">
      {children}
    </button>;
}